<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} STOCK UPDATES CONTENT</template>
		<template #body>

			<div class="form-floating mb-4">
				<input type="text" v-model="form.stock_title" id="stock_title" name="stock_title" class="form-control" placeholder="Title" />
				<label class="form-label" for="stock_title">Title</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="stock_tag">Add Tag</label>
				<div class="input-group">
					<input type="text" v-model="stock_tag" id="stock_tag" name="stock_tag" class="form-control" placeholder="Tag">
					<span class="input-group-btn">
						<button @click="addTag" type="button" class="btn btn-info"><i class="fa fa-plus me1"></i>Add</button>
					</span>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="stock_title">Tags</label>
				<div class="mt-1">
					<span v-for="tag in stock_tags" class="badge border me-2 text-black">
						{{tag}} 
						<button @click="removeTag(tag)" type="button" class="btn-block-option ms-2 text-danger">x</button>
					</span>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="stock_title">Short Description</label>
				<div class="mt-1">
					<textarea v-model="form.short_desc" class="form-control" rows="5"></textarea>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="stock_desc">Description</label>
				<!-- <div class="mb-2 text-muted">
					<p class="mb-1">Use this variable to customize the display</p>
					<span>[fname]</span>
					<span>[level]</span>
					<span>[expiry]</span>
				</div> -->
				<!-- <ckeditor v-model="form.description" :editor="editor" :config="editorConfig"></ckeditor> -->
				<textarea id="ckeditor_stock_update"></textarea>
			</div>
			<div class="form-floating mb-4">
				<div class="mb-4">
					<label class="form-label" for="stock_image">Image</label>
					<p class="text-danger fw-bold m-0">Recommended Size: width:1150px height:648px</p>
					<input
						@change="onFileChange"
						type="file"
						id="stock_image"
						name="stock_image"
						class="form-control"
						:accept="[
			            'image/jpeg',
			            'image/jpg',
			            'image/png'
			          ]"
					/>
				</div>
				<div class="mb-4">
					<div v-if="form.prev_stock_image!=null"
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
						:class="{'opacity-25':(form.stock_image!=form.prev_stock_image && form.prev_stock_image!=null && action=='update')}"
					>
						<img :src="form.stock_image_url" style="width:100%;" />
					</div>
					<div v-if="form.stock_image!=form.prev_stock_image && form.prev_stock_image!=null && action=='update'" class="text-center text-muted">
						<i class="fa fa-arrow-down fa-2x"></i>
					</div>
					<div>
						<div id="image-preview" 
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="background-size: contain;background-repeat: no-repeat;background-position: center;"
						:style="{'height':(form.stock_image!=form.prev_stock_image)?'300px':'0px'}">
							
						</div>
						<div v-if="form.stock_image!=form.prev_stock_image && form.prev_stock_image!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
					</div>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="start_datetime">Date Start</label>
				<flat-pickr
					v-model="form.date_start"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y',
						dateFormat: 'Y-m-d',
					}"
					class="form-control"
					:class="
						form.errors.start_date
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="is_active">Status</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_on"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">ON</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_off"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
					</div>
				</div>
			</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import CKEditorInit from './../../Shared/ckeditor-init';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
// import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
// import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import SourceEditing from '@ckeditor/ckeditor5-source-editing/src';


// class MyUploadAdapter {
//     constructor( loader ) {
//         // The file loader instance to use during the upload.
//         this.loader = loader;
//     }

//     // Starts the upload process.
//     upload() {
//         return this.loader.file
//             .then( file => new Promise( ( resolve, reject ) => {
//                 // this._initRequest();
//                 // this._initListeners( resolve, reject, file );
//                 // this._sendRequest( file );

//                 let uploadedFile = file;

//                 const data = new FormData()
//                 data.append("upload", uploadedFile)

//                 axios.post('/api/admin/stock-updates/upload/image', data, {
//                         headers: {
//                             'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
//                             'Accept': 'application/json'
//                         }
//                     })
//                     .then((res)=>{
//                         if ( res.data.result == "success" ) {
//                             resolve( {
//                                 default: "https://playgroundbucket1.s3.ap-southeast-1.amazonaws.com/stock-updates/upload/images/"+res.data.data
//                             } );
//                         } else {
//                             reject(res.data.data);
//                         }
                        
//                     })
//                     .catch((error)=>{
//                         console.log(error);
//                     });

//             } ) );
//     }

//     // Aborts the upload process.
//     abort() {
//         // if ( axios ) {
//         //     axios.abort();
//         // }
//         reject();
//     }

// }


// function MyCustomUploadAdapterPlugin( editor ) {
//     editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
//         // Configure the URL to the upload script in your back-end here!
//         return new MyUploadAdapter( loader );
//         // return new myuploader( loader );
//     };
// }

export default {
	props: {
		
	},
	mounted(){
		// window.Codebase.helpersOnLoad(['ckeditor_stock_update']);
		CKEditorInit('ckeditor_stock_update');
	},
	setup(props) {
		const modal = ref(null);

		// const editor 		= ref(ClassicEditor);
		const editor 		= ref(null);
		const editorConfig 	= {
			// extraPlugins : [MyCustomUploadAdapterPlugin]
			                    
			                    // plugins: [
			                    //     // EssentialsPlugin,
			                    //     // BoldPlugin,
			                    //     // ItalicPlugin,
			                    //     // LinkPlugin,
			                    //     // ParagraphPlugin,
			                    //     SourceEditing
			                    // ],

			                    // // toolbar: {
			                    // //     items: [
			                    // //         // 'bold',
			                    // //         // 'italic',
			                    // //         // 'link',
			                    // //         // 'undo',
			                    // //         // 'redo',
			                    // //         'sourceEditing'
			                    // //     ]
			                    // // }
			                    // toolbar:['sourceEditing']
		                    
							};

		const stock_tag = ref(null);

		const stock_tags = ref([]);
		
		const action = ref('add');

		const form = useForm({
			stock_update_uuid	: 0,
			category 			: 'stock_update',
			stock_tags 			: null,
			stock_title 		: null,
			short_desc 			: '',
			stock_desc 			: '',
			prev_stock_image 	: null,
			stock_image 		: null,
			stock_image_url 	: null,
			date_start 			: null,
			date_published 		: null,
			is_active 			: 0
		})

		const toggleModal = () => {
			
			if(action.value=='add')
			{
				// CKEDITOR.instances['ckeditor_stock_update'].setData('<p></p>');
				window['ckeditor_stock_update'].setData('<p></p>');
				stock_tags.value = null;
			}else
			{
				if(form.stock_desc!==null)
				{
					window['ckeditor_stock_update'].setData(form.stock_desc);	
				}
				
			}

			modal.value.toggleModal();
			
		}

		const addTag = ()=>{
			
			stock_tags.value.push(stock_tag.value);
			
			configStockTags();
			stock_tag.value = null;
		}

		const removeTag = (_level)=>{
			stock_tags.value = stock_tags.value.filter((data)=>{
				if(_level!=data)
				{
					return data;
				}
			})

			configStockTags();
		}

		const configStockTags = ()=>{
			if(stock_tags.value.length==0)
			{
				stock_tags.value 	= null;
				form.stock_tags 	= null;
			}else{
				for (var i = 0; i < stock_tags.value.length; i++) {
					var tag = stock_tags.value[i];
					if(i==0)
					{
						form.stock_tags = tag;
					}else{
						form.stock_tags += ","+tag;	
					}
					
				}
			}
		}

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#stock_image").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.stock_image = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.stock_image = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.stock_image = form.prev_stock_image;
			clearUpload();
		}

		const actionContent = ()=>{

			// form.description = CKEDITOR.instances['ckeditor_stock_update'].getData();
			form.stock_desc = window['ckeditor_stock_update'].getData();

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.stock-updates'), {
				preserveState: true,
				preserveScroll: true,
				only:['stock_updates,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('stock-updates/'+form.stock_update_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['stock_updates,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setStockUpdateContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.stock_update_uuid 		= data.stock_update_uuid;
									form.stock_title 			= data.stock_title;
									form.stock_tags 			= data.stock_tags;
									form.short_desc 			= data.short_desc;
									form.stock_desc 			= data.stock_desc;
									form.prev_stock_image 		= data.prev_stock_image;
									form.stock_image 			= data.stock_image;
									form.stock_image_url 		= data.stock_image_url;
									form.is_active 				= data.is_active;
									form.date_start 			= data.date_start;
									form.date_published 		= data.date_published;

									if(data.stock_tags!==null)
										stock_tags.value 			= data.stock_tags.split(",");

								}
								
							}


		return {
			form,
			stock_tag,
			stock_tags,
			modal,
			// editor,
			editorConfig,
			toggleModal,
			action,
			clearUpload,
			removeUploadImage,
			onFileChange,
			setStockUpdateContent,
			addTag,
			removeTag,
			configStockTags,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>

<style>
	.ck-content,.ck-source-editing-area{
		height: 300px;
	}
	
	.ck-content, .ck.ck-balloon-panel{
		z-index: 1055;
	}
</style>